import { render, staticRenderFns } from "./AppConfirmationModal.vue?vue&type=template&id=0bb08515&scoped=true&"
import script from "./AppConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./AppConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb08515",
  null
  
)

export default component.exports